<!-- mainSlideWrap -->
<div class="mainSlideWrap">
    <div class="swiper mainSlide">
        <div class="swiper-wrapper">
            <ng-container *ngFor="let item of contentsBanner;">
                <div class="swiper-slide">
                    <a routerLink="{{ item.linkInfo }}">
                        <img src="{{ urlWownet + item.filePath + item.fileName }}" alt="{{ item.fileName }}" />
                    </a>
                </div>
            </ng-container>            
        </div>
        <div class="control">
            <div class="container">
                <div class="swiper-button-prev">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
                </div>
                <div class="swiper-button-next">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>
                </div>
                <div class="swiper-pagination"></div>
            </div>
        </div>
    </div>
</div>
<!-- //mainSlideWrap -->